<template>

    <header>
        <div class="margin-top center">
            <router-link to="/" class="logo">
                <img
                    src="https://hawesptsa.myshopify.com/cdn/shop/files/PTSA_logo_1_horizontal1024.png?v=1695171751&width=300"
                    alt="Hawes PTSA Logo">
            </router-link>
        </div>
    </header>

    <main class="container-relative">

        <router-view></router-view>

    </main>

    <footer style="min-height: 60px; font-size: .8em; padding: 20px" class="margin-top-lg">
        <div v-if="session" class="center margin-bottom-sm">
            You are currently logged in as <strong>{{ session.email }}</strong>
        </div>
        <div class="center">
            <a href="https://hawesptsa.myshopify.com/" target="Hawes">Hawes PTSA Website</a>
            &bullet; <a href="https://hawesptsa.myshopify.com/pages/about-us-1" target="Hawes">About Us</a>
            &bullet; <a href="https://hawesptsa.myshopify.com/pages/contact" target="Hawes">Contact Us</a>
            &bullet; <a href="/privacy" target="privacy">Privacy Policy</a>
            &bullet; <a href="/terms-of-service" target="tos">Terms of Service</a>
            <template v-if="canOps">
                &bullet;
                <a href="https://office.hawesptsa.org/directory">Office</a>
            </template>
            <template v-if="session">
                &bullet;
                <router-link to="/logout"><strong>Logout</strong></router-link>
            </template>
        </div>
    </footer>

</template>

<script setup>

import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {parseJSON} from "@fennecstudio/utils";

const store = useStore();

const session = computed(() => store.state.session);
const canOps = computed(() => session.value?.role === 'admin')

onMounted(() => {
    store.dispatch('updateSession', parseJSON(localStorage.getItem('session')));
});

</script>

<style lang="scss">



.break-word {
    word-break: break-word;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
main.container {
    padding: 20px
}

@media (min-width: 952px) {
    article.body, .container {
        max-width: 952px;
        margin-left: auto;
        margin-right: auto;
    }
}

a {
    cursor: pointer;
    text-decoration: none;
}

a.logo {
    cursor: pointer;
    text-decoration: none;
    border-radius: 12px;
    padding: 0 10px 10px;
    background-color: white;
    display: inline-block;
}

a.back-link {
    display: inline-block;
    margin: 10px 20px;
    cursor: pointer;
}

.danger, .error {
    color: #af1111;
}

button.danger {
    color: white;
    border-color: #af1111;
    background-color: #af1111;
}

.no-wrap {
    white-space: nowrap;
}

.margin-top {
    margin-top: 20px;
}

.margin-top-sm {
    margin-top: 10px;
}

.margin-top-lg {
    margin-top: 40px;
}

.margin-bottom {
    margin-bottom: 20px;
}

.margin-bottom-sm {
    margin-bottom: 10px;
}

.margin-bottom-lg {
    margin-bottom: 40px;
}

.margin-right {
    margin-right: 20px;
}

.margin-right-sm {
    margin-right: 10px;
}

.margin-right-lg {
    margin-right: 40px;
}

.margin-left {
    margin-left: 20px;
}

.margin-left-sm {
    margin-left: 10px;
}

.margin-left-lg {
    margin-left: 40px;
}

.margin-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}

.button-sm {
    padding: 2px 6px;
}

.flex-row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center
}

.flex1 {
    flex: 1;
}

.center {
    text-align: center;
}

.pointer {
    cursor: pointer;
}


[aria-label="breadcrumb"] {
    font-size: .8em
}

html[data-theme="light"] {
}

html[data-theme="dark"] {
}
</style>